export default "__VITE_ASSET__ohQQRB9$__"